import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "隱私條款" }) => {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <HeadingRow>
                        <Heading>{headingText}</Heading>
                    </HeadingRow>
                    <Text>
                        <p>生效日期： 2024 年 3 月 1 日</p>
                        <p> 歡迎來到紅隼遊戲！紅隼公司致力于保護您的個人信息和隱私。本隱私政策協議將解釋我們如何在您使用紅隼的遊戲時收集、使用和保護您提供給我們的信息。請在使用我們的服務之前仔細閱讀此協議。 </p> <p> 我們使用您的個人數據來提供和改進服務。通過使用本服務，您同意根據本隱私政策收集和使用信息。 </p> <p> 感謝您玩我們的遊戲！本隱私政策描述了： </p> <ul> <li> <p> 我們如何收集您的個人數據以及我們這樣做的原因 </p> </li> <li> <p> 我們如何使用您的個人數據 </p> </li> <li> 您對個人數據擁有的選擇權。 </li> </ul> <p> 本隱私政策適用于紅隼的遊戲、商店、網站和相關服務，我們統稱爲“服務”。我們可能會通過在 falcon-games.com 上發布新版本定期更新本隱私政策。如果我們做出任何重大更改，我們將在變更生效前在服務中發布通知，告知您這些更改。您在變更生效日期之後繼續使用服務，將受新的隱私政策的約束。 </p>  <h2>我們收集的數據</h2> <p> 我們收集的個人數據類別取決于您使用的服務以及適用法律的要求。 </p> <p> 您直接提供給我們的數據。 </p> <p> ▪ 聯系信息（例如電子郵件地址） </p> <p> ▪ 玩家名稱或 ID 及密碼 </p> <p> ▪ 個人資料信息（例如個人資料照片） </p> <p> ▪ 您在使用服務時提交的消息和其他內容（例如聊天記錄和玩家支持工單） </p> <p> ▪ 您在參與調查、促銷、抽獎、比賽和其他活動時提供的數據 </p> <p> ▪ 我們的支付服務提供商將在您通過紅隼商店進行購買時收集您的支付詳情 </p> <h2>我們自動收集的數據</h2> <p> ▪ 有關您的賬戶和遊戲進度的數據，包括在大多數情況下自動創建的內部賬戶 ID </p> <p> ▪ 您的 IP 地址和移動設備標識符（如設備 ID 或廣告 ID） </p> <p> ▪ 有關您設備的數據，例如設備名稱和操作系統、浏覽器類型和語言、互聯網服務提供商和移動運營商 </p> <p> ▪ 我們通過 Cookie 和類似技術收集的數據（見下文） </p> <p> ▪ 大致位置信息（由 IP 地址推斷） </p> <p> ▪ 您使用服務的相關數據，例如遊戲數據、購買記錄以及您與其他玩家在服務中的互動 </p> <p> 您還可以選擇使用您的電子郵件地址或其他聯系信息創建紅隼 ID。 </p> <h2>我們從合作夥伴處收集的數據</h2> <p> 我們還使用第三方合作夥伴，例如社交網絡網站、數據分析提供商和廣告網絡來補充我們對您的信息，如： </p> <p> ▪ 如果您將第三方工具與服務關聯（如某些市場中的 LINE、微信或 Meta），我們接收的數據 </p> <p> ▪ 人口統計數據（例如根據您的 IP 地址確定的大致位置） </p> <p> ▪ 用于打擊欺詐的數據（如遊戲中的退款濫用或廣告中的點擊欺詐） </p> <p> ▪ 遊戲運行平台或支付服務提供商提供的數據（如支付驗證數據） </p> <p> ▪ 用于廣告和分析的數據（如調查），以便我們爲您提供更好的服務 </p> <p> ▪ 您通過隱私設置從第三方服務（如某些市場中的 LINE、微信或 Meta）向我們提供的數據 </p> <h2>我們爲何收集您的數據</h2> <p> 我們使用您的數據進行多種業務用途，例如： </p> <p> 使服務正常運作。 </p> <p> 爲履行合同，我們處理必要的數據以： </p> <p> ▪ 創建賬戶並允許您玩我們的遊戲並使用我們的服務 </p> <p> ▪ 運營服務 </p> <p> ▪ 驗證和確認付款 </p> <p> ▪ 提供和交付您請求的産品和服務 </p> <p> ▪ 向您發送服務相關的通訊 </p> <h2>讓服務更適合我們的玩家</h2> <p> 爲向玩家提供優質服務，我們有合法利益收集和處理必要數據以： </p> <p> ▪ 更新和開發玩家資料 </p> <p> ▪ 開發和改進服務和玩家體驗 </p> <p> ▪ 管理我們與您的關系 </p> <p> ▪ 提供社交功能作爲服務的壹部分 </p> <p> ▪ 定制您的服務體驗 </p> <p> ▪ 回應您的評論和問題並提供玩家支持 </p> <p> ▪ 在服務中以及其他網站和服務（包括電子郵件）向您提供紅隼的優惠 </p> <p> ▪ 向您發送相關信息，如更新、安全提醒和支持消息 </p> <p> ▪ 使您能夠與其他玩家進行交流 </p>
                        <h2>顯示個性化廣告</h2>
                        <p>
                            爲了在服務中和其他地方（包括電子郵件）向您展示個性化廣告，我們有合法利益處理必要的數據以：
                        </p>

                        <p>
                            ▪ 跟蹤您在使用服務時訪問的內容以及您的在線行爲
                        </p>

                        <p>
                            ▪ 提供、定位和改進我們的廣告和服務
                        </p>

                        <h2>保持服務安全公平</h2>
                        <p>
                            確保服務的公平性是我們的首要任務。更多信息請參見我們的《紅隼服務條款》。
                        </p>

                        <p>
                            爲了保持服務及其社交功能的安全和公平，打擊欺詐行爲並確保其他合理使用，我們有合法利益處理必要數據以：
                        </p>

                        <p>
                            ▪ 分析和監控服務及其社交功能的使用情況
                        </p>

                        <p>
                            ▪ 自動或手動審核聊天內容
                        </p>

                        <p>
                            ▪ 針對欺詐或不良行爲的玩家采取措施
                        </p>

                        <h2>進行分析、畫像和分段</h2>
                        <p>
                            在上述所有情況和目的中，我們可能會對所有收集的數據進行分析、畫像和分段。
                        </p>

                        <h2>在您的同意下</h2>
                        <p>
                            在您的同意下，我們可能會出于其他目的處理您的數據。
                        </p>

                        <p>
                            我們還可能收集並使用您的設備標識符以展示並個性化遊戲內廣告，並提供定向行爲廣告，如下所述。根據適用的隱私法律，包括《通用數據保護條例》（GDPR），我們需要征得您的同意才能這樣做。
                        </p>

                        <p>
                            這些數據是在您同意的情況下共享的，以便我們的廣告合作夥伴能夠提供合適的廣告並優化廣告內容，確保您不會重複看到同壹廣告。我們將您的設備標識符與選定的合作夥伴共享，以便進行廣告投放和個性化設置。
                        </p>

                        <p>
                            您可以在遊戲設置中管理您的同意，並在設備設置中限制廣告跟蹤。請注意，選擇退出廣告跟蹤是特定于每個浏覽器和設備的，可能需要壹些時間才能生效。
                        </p>

                        <p>
                            對于應用中的移動廣告，您可以重置您的廣告標識符，並根據您的設備選擇退出基于興趣的廣告（Android）或打開“限制廣告跟蹤”設置（iOS）。
                        </p>

                        <p>
                            合作夥伴運營廣告網絡和中介平台，參與廣告庫存競價。合作夥伴還可能基于其合法利益使用設備標識符進行欺詐檢測。更多信息請查看合作夥伴的隱私政策。
                        </p>

                        <p>
                            ironSource隱私政策：<a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1" target="_blank" rel="noopener noreferrer">https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1</a>
                        </p>

                        <p>
                            Vungle隱私政策：<a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">https://vungle.com/privacy/</a>
                        </p>

                        <p>
                            Google隱私政策：<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                        </p>

                        <p>
                            Liftoff隱私政策：<a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">https://liftoff.io/privacy-policy/</a>
                        </p>

                        <p>
                            Mintegral隱私政策：<a href="https://www.mintegral.com/en/privacy" target="_blank" rel="noopener noreferrer">https://www.mintegral.com/en/privacy</a>
                        </p>

                        <p>
                            Unity Ads隱私政策：<a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://unity.com/legal/privacy-policy</a>
                        </p>

                        <p>
                            Facebook隱私政策：<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a>
                        </p>

                        <p>
                            Apple搜索廣告隱私政策：<a href="https://searchads.apple.com/privacy" target="_blank" rel="noopener noreferrer">https://searchads.apple.com/privacy</a>
                        </p>

                        <p>
                            Applovin隱私政策：<a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.applovin.com/privacy/</a>
                        </p>

                        <p>
                            inMobi隱私政策：<a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://advertising.inmobi.com/privacy-policy</a>
                        </p>

                        <p>
                            Pangle隱私政策：<a href="https://www.pangleglobal.com/zh/privacy" target="_blank" rel="noopener noreferrer">https://www.pangleglobal.com/zh/privacy</a>
                        </p>

                        <p>
                            DT Exchange隱私政策：<a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.digitalturbine.com/legal/privacy-policy</a>
                        </p>

                        <p>
                            Chartboost隱私政策：<a href="https://docs.chartboost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://docs.chartboost.com/en/legal/privacy-policy</a>
                        </p>
                        <p>
                            TapSDK隱私政策: <a href="https://www.tapdb.com/tapsdk-privacy.html" target="_blank" rel="noopener noreferrer">https://www.tapdb.com/tapsdk-privacy.html</a>
                        </p>
                        <p>
                            talkingdata隱私政策: <a href="https://www.talkingdata.com/privacy.jsp" target="_blank" rel="noopener noreferrer">https://www.talkingdata.com/privacy.jsp</a>
                        </p>

                        <h2>誰能看到您的數據</h2>
                        <p>
                            除了紅隼外，其他人在以下情況下可以訪問您的數據：
                        </p>

                        <p>
                            其他玩家和用戶。
                        </p>

                        <p>
                            社交功能是我們遊戲的核心組成部分。其他玩家和用戶可能會看到您的個人資料數據、遊戲內活動，並閱讀您發布的消息。
                        </p>

                        <p>
                            我們的服務提供商。
                        </p>

                        <p>
                            紅隼擁有幫助我們提供服務的供應商。這些供應商僅按照紅隼的指示處理您的數據，以提供服務並執行諸如托管、玩家支持、廣告、分析和防欺詐等任務。
                        </p>

                        <p>
                            其他公司和公共機構。
                        </p>

                        <p>
                            爲了驗證付款（與支付提供商如 PayPal）並打擊欺詐和非法活動，我們可能會處理和披露數據與其他公司和組織共享，並應法律要求向公共機構提供。
                        </p>

                        <p>
                            我們還可能基于您的同意披露您的數據，遵守法律，或保護我們、我們的玩家或其他人的權利、財産或安全。
                        </p>

                        <p>
                            廣告和社交媒體合作夥伴。
                        </p>

                        <p>
                            服務包含我們合作夥伴的功能，如社交媒體互動工具、通過應用編程接口（API）或軟件開發工具包（SDK）的功能，以及遊戲內廣告。在“根據您的同意”部分列出了這些合作夥伴。這些合作夥伴可能會訪問您的數據，並根據他們的隱私政策操作。我們鼓勵您查看他們的隱私政策，了解更多他們的數據處理實踐。
                        </p>

                        <p>
                            這些合作夥伴可能會訪問有關您活動和設備的數據（如您的 IP 地址、移動設備標識符、訪問的頁面、位置、時間）。我們也可能會將我們收集到的關于您的數據與第三方廣告合作夥伴共享。這些廣告合作夥伴可能會將這些數據（以及從其他服務收集的類似數據）用于在他們的網絡內向您投放定向廣告。這些合作夥伴可能根據他們的隱私政策操作。這種做法通常被稱爲“基于興趣的廣告”或“在線行爲廣告”。
                        </p>

                        <h2>國際數據傳輸</h2>
                        <p>
                            我們的服務具有全球性，因此您的數據可能會被傳輸到世界各地。由于不同國家的數據保護法律可能與您所在國家的法律不同，我們會采取措施確保有適當的保障措施來保護您的數據，如本隱私政策中所述。我們可能會使用的適當保障措施包括歐盟委員會批准的標准合同條款以及其他合法的保障措施。
                        </p>

                        <h2>您的權利與選擇</h2>
                        <p>
                            取消訂閱營銷電子郵件和其他直接營銷。
                        </p>

                        <p>
                            在適用法律允許的情況下，紅隼可能會基于現有的客戶關系向您發送營銷通訊。
                        </p>

                        <p>
                            您可以通過按照這些通訊中的說明操作或更改遊戲內設置來選擇不接收我們的促銷通訊。更新的設置可能不會立即生效。請注意，您可能仍然會繼續收到我們發送的非促銷通訊，例如有關服務的通訊、我們紅隼服務條款或本隱私政策的更新通知，或與您在服務中的購買相關的交易信息。
                        </p>
                        <h2>推送通知</h2> <p> 我們可能會通過我們的移動應用程序向您發送推送通知。您可以隨時通過更改移動設備上的設置選擇不再接收這些類型的通訊。 </p> <h2>退出定向廣告</h2> <p> 您可以通過檢查 Android 或 iOS 設備的隱私設置，關閉“允許應用請求跟蹤”或選擇“限制廣告跟蹤”（Apple iOS）或“退出基于興趣的廣告”（Android），退出移動應用程序中的基于興趣的廣告。您還可以通過遊戲設置中提供的選項（如適用）退出個性化的遊戲內優惠。 </p> <p> 訪問我們持有的關于您的個人數據。 </p> <p> 如果您提出請求，我們將以電子格式向您提供壹份您的個人數據副本。 </p> <h2>您的其他權利</h2> <p> 您還擁有更正數據、刪除數據、反對我們如何使用或共享您的數據以及限制我們使用或共享您的數據的權利。您可以隨時撤回您的同意。 </p> <p> 我們會在合理的時間內回複所有請求。如果您有任何未解決的隱私或數據使用問題，而我們未能令人滿意地解決，您也可以聯系歐洲經濟區、瑞士或英國的當地數據保護機構，以解決未解決的投訴。 </p> <p> 如果您希望行使上述任何數據主體權利，請使用“聯系我們”部分中描述的支持選項。我們將根據適用法律回複所有請求。爲了保護您的隱私，我們可能還會采取其他步驟來驗證您的身份，例如要求您提供購買憑證或其他賬戶信息，要求您將您的電子郵件地址與您的遊戲賬戶關聯（例如通過遊戲 ID），或者要求您回答有關您在我們服務中的活動的問題。身份驗證後，您還可以指定授權代理人代表您行使您的權利，方法是向我們的客戶支持人員提供代理人的聯系信息，根據適用法律的要求。 </p> <p> 您有權不因行使這些權利而受到歧視性待遇。 </p> <h1>我們如何保護您的數據</h1> <h2>安全保障</h2> <p> 爲了確保玩家擁有安全的體驗，我們不斷開發和實施管理、技術和物理安全措施，以保護您的數據免受未經授權的訪問、丟失、濫用或篡改。 </p> <h2>數據保留</h2> <p> 只要您的賬戶處于活躍狀態或在提供服務所需的時間內，我們將保留您的數據。例如，我們可能會定期去識別未使用的遊戲賬戶，並定期審查和去識別不必要的數據。 </p> <p> 請注意，如果您要求我們刪除您的個人數據，我們將根據我們的合法商業利益保留您的數據，例如履行我們的法律義務、解決爭議並執行我們的協議。 </p> <h1>兒童隱私</h1> <p> 保護兒童的在線隱私對我們來說非常重要。通常，我們的服務並非專爲13歲以下的兒童（或當地法律要求的其他年齡）設計，服務也不會有意收集兒童的個人數據，除非以下段落中所述。 </p> <p> 對于那些未專爲兒童設計但可能吸引兒童的遊戲，我們采取了額外措施根據玩家的年齡限制訪問這些服務。對于這些服務，當玩家表明其年齡在13歲以下（或其所在地區的適用年齡）時，我們將限制他們訪問某些功能，如社交媒體和聊天功能，以及某些類型的通知警報。我們還會將個人數據的處理限制在支持我們服務內部運營所必需的範圍內。 </p> <p> 請注意，對于我們的某些服務，我們可能會使用比上述段落更高的年齡限制（例如16歲）。我們這樣做是爲了爲玩家提供安全的遊戲體驗，並保護年輕玩家。 </p> <p> 如果您是家長或監護人，想要查看我們從您的孩子那裏收集的個人數據，或希望修改或刪除這些信息，您可以通過上文描述的方式與我們聯系。如果我們發現兒童違反上述規定向我們提供了個人數據，我們將刪除我們所收集的任何個人數據，除非我們有法律義務保留這些數據，並終止該兒童的賬戶和/或將其轉換爲未成年體驗模式（如適用）。 </p> <h1>加州居民權利</h1> <p> 以下部分僅適用于加利福尼亞州居民。 </p> <h2>1) 數據收集</h2> <p> 我們在過去12個月內收集的個人數據類別及其來源已在“我們收集的數據”部分中描述。 </p> <h2>2) 數據使用</h2> <p> 我們收集您個人數據的商業或業務目的已在“我們爲何收集您的數據”部分中描述。 </p> <h2>3) 數據披露和/或出售</h2> <p> 我們不會像大多數人理解的那樣“出售”您的個人數據給第三方。但是，我們可能會與第三方廣告平台共享您的 Cookie 信息和廣告標識符，以提供基于興趣的廣告、歸因安裝和優化廣告活動。如果這種做法在《加州消費者隱私法》（CCPA）下被視爲“銷售”，您可以按照“退出定向廣告”部分中描述的步驟，選擇退出這種共享。 </p> <p> 我們沒有實際了解到任何16歲以下未成年人個人數據的出售行爲，正如 CCPA 中“出售”壹詞的定義所述。 </p> <p> 在過去的12個月內，作爲我們服務的壹部分，我們已披露了以下類別的個人數據：</p>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>收集的個人數據類別</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Red Falcon 收集的數據示例</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>可能出于業務目的接收個人數據的第三方類別</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>標識符</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>真實姓名、別名、唯壹個人標識符、在線標識符、互聯網協議地址、電子郵件地址、賬戶名稱或其他類似標識符。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>其他玩家(僅用戶名和個人資料)、服務提供商、業務合作夥伴、廣告網絡(僅廣告標識符和IP地址)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>加州客戶記錄法案(Cal. Civ. Code § 1798.80(e))中列出的個人數據類別</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>姓名或電話號碼。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服務提供商</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>加州或聯邦法律下的受保護分類特征</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>年齡。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服務提供商、廣告網絡(僅用于合規目的)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>商業信息</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>購買、獲得或考慮的産品或服務記錄，或其他購買或消費曆史或傾向。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服務提供商、廣告網絡</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>互聯網或其他電子網絡活動</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>浏覽曆史、消費者與互聯網網站、應用程序或廣告的互動信息。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服務提供商、廣告網絡</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>從其他個人數據推斷出的消費者檔案</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>反映消費者偏好、特征和行爲的檔案。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服務提供商</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            除了上述共享情況外，我們可能會將我們收集的任何關于您的信息與我們的關聯公司共享，以保護我們或他人，或在合並、出售或其他資産轉移的情況下共享。有關更多信息，請參閱“誰能看到您的數據”部分。
                        </p>

                        <h2>4) 您的權利</h2>
                        <p>
                            您在加利福尼亞州法律下的權利已在“您的權利和選擇”部分中描述。
                        </p>

                        <h1>土耳其居民</h1>
                        <p>
                            生效日期：2022年6月1日
                        </p>
                        <p>
                            以下部分適用于位于土耳其共和國的相關數據主體。
                        </p>

                        <h2>1) 數據收集與處理</h2>
                        <p>
                            您的個人數據將根據數據保護法規，特別是土耳其《個人數據保護法》（第6698號法律“DPL”）進行處理。
                        </p>
                        <p>
                            我們收集的個人數據類別及其來源已在全球隱私政策的“我們收集的數據”部分中描述。
                        </p>
                        <p>
                            我們收集您個人數據的目的已在“我們爲何收集您的數據”部分中說明。除此之外，您的個人數據將自動收集並根據《DPL》下的以下法律依據處理：
                        </p>
                        <p>
                            ▪ 第5/2(f)條
                        </p>
                        <p>
                            ▪ 第5/2(c)條
                        </p>
                        <p>
                            ▪ 第5/1條
                        </p>

                        <h2>2) 您的權利</h2>
                        <p>
                            您根據《DPL》第11條，擁有以下與我們持有的個人信息數據相關的合法權利。作爲從土耳其共和國訪問服務的數據主體，您可以向數據控制者申請，並在適用法律法規允許的範圍內：
                        </p>
                        <p>
                            1. 了解您的個人數據是否被處理，
                        </p>
                        <p>
                            2. 要求提供有關您的個人數據是否已被處理的信息，
                        </p>
                        <p>
                            3. 了解處理您個人數據的目的以及這些個人數據是否符合目的使用，
                        </p>
                        <p>
                            4. 了解您的個人數據在國內或國外被轉移至哪些第三方，
                        </p>
                        <p>
                            5. 要求更正不完整或不准確的數據（如有），
                        </p>
                        <p>
                            6. 在《DPL》第7條規定的條件下，要求刪除或銷毀您的個人數據，
                        </p>
                        <p>
                            7. 要求將執行的(e)和(f)項操作報告給您的個人數據被轉移的第三方，
                        </p>
                        <p>
                            8. 反對通過僅自動系統處理的數據分析而對您個人産生不利結果，
                        </p>
                        <p>
                            9. 對因非法處理您的個人數據而遭受的損害提出賠償請求。
                        </p>

                        <h2>聯系我們</h2> <p> 如果您對數據保護有任何疑問，或有任何解決個人數據問題的請求，我們鼓勵您通過每個紅隼遊戲中的支持功能與我們聯系，以便我們能更快回複您。您也可以通過以下方式聯系： </p> <p> 控制者名稱：杭州红隼互娱文化有限公司 </p> <p> 地址：浙江省杭州市余杭区仓前街道时代天元城19幢6层601-2室 </p> <p> 收件人：隱私 </p> <p> 郵箱：support@falcon-games.com </p>

                    </Text>
                </ContentWithPaddingXl>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
